import { get } from 'lodash';
import useConfirmTipTicket from 'modules/POS/PaymentDetails/ConfirmTipTicket';
import { useTicketWrapper } from 'modules/POS/Receipts/context';
import cashierService from 'modules/POS/services';
import cashierApis from 'modules/POS/services/apis';
import { IApiCashierPaymentBody } from 'modules/POS/services/types/payment';
import { useDispatch } from 'react-redux';
import { IResponseData } from 'services/response';
import toast from 'utils/toast';
import { setPageLoading } from 'widgets/PageLoading';
import { cashierCtrl } from '../../cashier.controller';
import CashierActionButton, { ActionType } from '../../components/CashierActionButton';
import ModalGiftCardPayment, { ICashierGiftCardPaymentMethod, useModalGiftCardPaymentRef } from './ModalGiftCardPayment';
import { useSocketContext } from '../../hooks/useSocket';
const CashierGiftCardPayment = () => {
  const [completedTicketModalRef, completedTicketModalContext] = useConfirmTipTicket();
  const ref = useModalGiftCardPaymentRef();
  const ticketContext = useTicketWrapper();
  const socketContext = useSocketContext();

  const dispatch = useDispatch();
  const onClick = async () => {
    cashierCtrl.saveTicketPaymentWithCallBack((billId) => {
      if (billId) ref.current?.open(billId);
    });
  };

  const onPayment: ICashierGiftCardPaymentMethod = async (billId, paymentItem) => {
    const body: IApiCashierPaymentBody = {
      billId, payments: [paymentItem],
    };
    setPageLoading(true);
    try {
      const res: IResponseData<any> = await cashierApis.paymentTicket(body);
      if (res.data.data) {
        toast.success('Success');
        socketContext.alertPaymentSuccess(billId);
        dispatch(cashierService.actions.async.lstBillOnHold.fetch());
        const callback = () => {
          cashierCtrl.generateNewTicketAfterPayment();
        };
        if (!completedTicketModalRef.current) {
          ticketContext.completedTicket(billId, true);
          callback();
        } else {
          completedTicketModalRef.current.open(billId, callback);
        }
        return true;
      }
      throw res.data.data;
    } catch (error) {
      const msg = get(error, ['response', 'data', 'message'], 'Fail');
      toast.error(msg);
      return false;
    } finally {
      setPageLoading(false);
    }
  };
  return (
    <>
      <CashierActionButton
        type={ActionType.GIFT_CARD}
        onClick={onClick}
      />
      <ModalGiftCardPayment
        ref={ref}
        onPayment={onPayment}
      />
      {completedTicketModalContext}
    </>
  );
};

export default CashierGiftCardPayment;
